import { Component } from '@angular/core';
import { BaseModalComponent } from '../base-modal/base-modal.component';
import { GlobalComponent } from 'src/app/global-component';
import { EntityTypeEnum } from "src/app/core/enums/entity-type-id-enum";
import { EntityFileTypeEnum } from 'src/app/core/enums/entity-file-type-enum';
import { SafeResourceUrl } from '@angular/platform-browser';
import { BaseModel } from 'src/app/core/models/base.model';
import { FileUploadModel } from 'src/app/core/models/file/file-upload-model';
import { DefaultImageService } from 'src/app/core/services/default-image.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-base-modal-with-profile-photo',
  templateUrl: './base-modal-with-profile-photo.component.html',
  styleUrls: ['./base-modal-with-profile-photo.component.scss']
})
export abstract class BaseModalWithProfilePhotoComponent extends BaseModalComponent {

  protected profileId: string | undefined = undefined;
  protected override defaultImageService: DefaultImageService = new DefaultImageService();
  protected profileImageURL: string | SafeResourceUrl = GlobalComponent.defaultUserImage;
  protected coverImageURL: string | SafeResourceUrl = GlobalComponent.defaultUserImage;
  protected enumEntityFileType = EntityFileTypeEnum;

  setProfileImageUrl(modelProfileImageURL: string | undefined) {
    if (modelProfileImageURL) {
      this.profileImageURL = this.sanitizer.bypassSecurityTrustResourceUrl(`data:image/png;base64, ${modelProfileImageURL}`);
    } else {
      this.profileImageURL = this.defaultImageService.getDefaultUserImage();
    }

  }

  setCoverImageUrl(modelCoverImageURL: string | undefined) {
    if (modelCoverImageURL) {
      this.coverImageURL = this.sanitizer.bypassSecurityTrustResourceUrl(`data:image/png;base64, ${modelCoverImageURL}`);
    } else {
      this.coverImageURL = this.defaultImageService.getDefaultUserImage();
    }
  }

  uploadPhotoDirectly(model: BaseModel, event: any, entityFileType: EntityFileTypeEnum) {
    this.submitted = true;
    var file: File = event.target.files[0];
    if (file) {
      var reader = new FileReader();
      const formData = new FormData();
      formData.append(String(entityFileType), file);
      var sub = this.myFileApiService.uploadStagingFile(formData).subscribe(profilePhotoFileId => {
        if (profilePhotoFileId) {
          reader.readAsDataURL(file);
          reader.onload = () => {
            if (reader.result) {
              if (entityFileType == EntityFileTypeEnum.CoverPhoto) {
                this.setCoverImageUrl(reader.result.toString().split(',')[1]);
              } else {
                this.setProfileImageUrl(reader.result.toString().split(',')[1]);
              }
            }
          }

          //Check is used when loading legacy models which might not have a saved version of the FileUploadModel on them.
          if (model.fileUpload === undefined) {
            model.fileUpload = new FileUploadModel;
          } else {
            model.fileUpload.fileIdsToAdd = [];
          }

          model.fileUpload.fileIdsToAdd.push(profilePhotoFileId);
          this.profileId = profilePhotoFileId;
          sub.unsubscribe();
        }
      });
    }
    this.submitted = false;
  }

  loadProfilePhoto(modelId: string, entityType: EntityTypeEnum, profilePhotoFileId?: string, entityName?: string): any {
    this.profileImageURL = this.defaultImageService.getDefaultUserImage(entityName);
    if (profilePhotoFileId !== undefined) {
      this.myFileApiService.getEntityFile(entityType, modelId, profilePhotoFileId).subscribe(result => {
        if (result) {
          var reader = new FileReader();
          reader.readAsDataURL(result);
          reader.onload = () => {
            if (reader.result) {
              this.profileImageURL = this.sanitizer.bypassSecurityTrustResourceUrl(`data:image/png;base64, ${reader.result.toString().split(',')[1]}`);
            }
          }
        }
      });
    }
  }

  getEntityPhoto(entity: any, entityTypeEnum: EntityTypeEnum) {
      if (entityTypeEnum == EntityTypeEnum.Requisition) {
        entity.listPhoto = GlobalComponent.defaultDocumentImageUrl;
        if (entity.id && entity.imageUrl) {
          entity.listPhoto = environment.staticImageApiUrl + entity.imageUrl.split('/').pop();;
        }
      } else {
        entity.listPhoto = this.defaultImageService.getDefaultUserImage(entity.fullName);
        if (entity.id && entity.profilePhotoFileId) {
          this.myFileApiService.getEntityFile(entityTypeEnum, entity.id, entity.profilePhotoFileId).subscribe(result => {
            if (result) {
              var reader = new FileReader();
              reader.readAsDataURL(result);
              reader.onload = () => {
                if (reader.result) {
                  var sanitizedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(`data:image/png;base64, ${reader.result.toString().split(',')[1]}`);
                  entity.listPhoto = sanitizedUrl;
                }
              }
            }
          })
        }
      }
    }

  loadCoverPhoto(modelId: string, coverPhotoFileId: string, entityType: EntityTypeEnum) {
    this.myFileApiService.getEntityFile(entityType, modelId, coverPhotoFileId).subscribe(result => {
      if (result) {
        var reader = new FileReader();
        reader.readAsDataURL(result);
        reader.onload = () => {
          if (reader.result) {
            this.coverImageURL = this.sanitizer.bypassSecurityTrustResourceUrl(`data:image/png;base64, ${reader.result.toString().split(',')[1]}`);
          }
        }
      }
    });
  }

}
